import React from 'react';
import PopupModal from "../../../../../../../../components/Modal/PopupModal";
import {useTranslation} from "react-i18next";
import {ReactComponent as AlertIco} from "../../../../../../../../../images/icons/alert-error.svg";

interface Props {
    show: boolean;
    onHide: () => void;
}

const OutOfDeliveryZoneInfoModal = ({show, onHide}: Props) => {
    const {t} = useTranslation();

	return (
		<PopupModal
            title={t("modules.multistore.field.store_out_of_delivery_zone.title")}
            show={show}
            onHide={onHide}
            headerIconClassName="text-danger"
            headerIcon={<AlertIco/>}
            description={t("modules.multistore.field.store_out_of_delivery_zone.description")}
        />
	)
}

export default OutOfDeliveryZoneInfoModal;